export class ProdutoIdadeCompra {
  public idadeMaxima!: number;
  public valorMaximo!: number;
  public fatorRMC!: number;
  public prazoMaximo!: number;
}